// extracted by mini-css-extract-plugin
export var inputContainer = "_ih-0";